import { Component, DestroyRef, OnInit, input, inject } from '@angular/core';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { map, tap, debounceTime, distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
import { Customer } from '@app/core/stingray-api/models';
import { requireMatch } from '@app/validators/autocomplete-validator';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { of } from 'rxjs';
import { CustomersService } from '@app/core/stingray-api/services';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';

@Component({
    selector: 'unite-contact-autocomplete',
    templateUrl: './contact-autocomplete.component.html',
    styleUrls: ['./contact-autocomplete.component.scss'],
    imports: [MatFormField, MatLabel, MatProgressSpinner, MatSuffix, MatInput, ReactiveFormsModule, MatAutocompleteTrigger, MatAutocomplete, MatOption, TranslateModule, MatIcon]
})
export class ContactAutocompleteComponent implements OnInit {

  private destroyRef = inject(DestroyRef);
  control = input<FormControl>();
  required = input(false);
  focus = input(false);
  label = input<string>();

  contacts: Customer[] = [];
  contactsFiltered: Customer[];

  isLoadingContacts = false;

  constructor(
    private customersService: CustomersService) { }

  ngOnInit() {
    if (this.required() === false) {
      this.control().setValidators([requireMatch]);
    } else {
      this.control().setValidators([Validators.required, requireMatch]);
    }

    this.control().valueChanges.pipe(
      tap(() => this.isLoadingContacts = true),
      debounceTime(350),
      distinctUntilChanged(),
      takeUntilDestroyed(this.destroyRef),
      switchMap((value: any) => {
        if (value && typeof value === 'string' && value.trim() !== '') {
          return this.customersService.getCustomers({
            name: value,
            types: ['Person']
          }).pipe(map(data => data.items), catchError(() => of(null)));
        } else {
          this.isLoadingContacts = false;
          return of(null);
        }
      })).subscribe((contactsFiltered: Customer[]) => {
        this.contactsFiltered = contactsFiltered;
        this.isLoadingContacts = false;
      });
  }

  displayWithCustomer(contact: Customer): string {
    if (contact != null) {
      return contact.name;
    } else {
      return '';
    }
  }

  isCustomer(value: any | Customer): value is Customer {
    return value != null && (<Customer>value).id !== undefined;
  }
}
